import React from 'react';
import {
  bool, func, string, shape,
} from 'prop-types';
import { SlideIn, AccountMenu as AccountMenuPage } from '@hyphengroup/cag-components';
import { getDashboardDesktopMenuBar } from 'helpers/Utils';
import { dashboardLoginDashboardNavigationMenuClickEvent, withTracking } from 'components/tracking';

function AccountMenu({
  isAccountMenuShown,
  onLogoutClick,
  hideAccountMenu,
  showMobileMenu,
  logo,
  staticText,
  customerEmail,
  homePageURL,
  track,
}) {
  return (
    <SlideIn isOpen={isAccountMenuShown} height="100vh">
      <AccountMenuPage
        menuLinks={[
          {
            to: `${homePageURL}/${staticText.DASHBOARD_PROFILE_ROUTE_NAME}`,
            title: staticText.MENU_EDIT_PROFILE,
            dataSelectorId: 'profileMenuLink',
            handler: () => dashboardLoginDashboardNavigationMenuClickEvent(track, 'My profile'),
          },
          {
            to: `${homePageURL}/${staticText.DASHBOARD_ROUTE_NAME}`,
            title: staticText.DASHBOARD,
            dataSelectorId: 'dashboardMenuLink',
            handler: () => dashboardLoginDashboardNavigationMenuClickEvent(track, 'Dashboard'),
          },
          {
            to: `${homePageURL}/${staticText.DASHBOARD_SETTINGS_ROUTE_NAME}`,
            title: staticText.MENU_SETTINGS,
            dataSelectorId: 'settingsMenuLink',
            handler: () => dashboardLoginDashboardNavigationMenuClickEvent(track, 'Settings'),
          },
        ]}
        desktopMenuBar={getDashboardDesktopMenuBar(staticText)}
        onHelpClick={() => { dashboardLoginDashboardNavigationMenuClickEvent(track, 'Help'); }}
        logo={logo}
        menuTextLogOut={staticText.MENU_LOG_OUT}
        menuTextHelp={staticText.MENU_HELP}
        menuTextHelpLink={staticText.MENU_HELP_LINK}
        salutationPrefix={staticText.MENU_SALUTATION_PREFIX}
        customerEmail={customerEmail}
        onLogoutClick={onLogoutClick}
        hideAccountMenu={hideAccountMenu}
        showMobileMenu={showMobileMenu}
        staticText={staticText}
        homePageURL={homePageURL}
      />
    </SlideIn>
  );
}

AccountMenu.defaultProps = {
  track: null,
  isAccountMenuShown: false,
};

AccountMenu.propTypes = {
  track: func,
  isAccountMenuShown: bool,
  onLogoutClick: func.isRequired,
  hideAccountMenu: func.isRequired,
  showMobileMenu: func.isRequired,
  logo: shape({
    link: shape({
      href: string.isRequired,
    }).isRequired,
    title: string.isRequired,
    imageUrl: string.isRequired,
  }).isRequired,
  staticText: shape({
    DASHBOARD: string.isRequired,
    MENU_EDIT_PROFILE: string.isRequired,
    MENU_LOG_OUT: string.isRequired,
    MENU_SETTINGS: string.isRequired,
    MENU_SALUTATION_PREFIX: string.isRequired,
    MENU_HELP: string.isRequired,
    MENU_HELP_LINK: string.isRequired,
  }).isRequired,
  customerEmail: string.isRequired,
  homePageURL: string.isRequired,
};

export default withTracking(AccountMenu);
